<template>
  <div class="recovery-main">
    <!-- <v-row justify="center" class="mt-10"> -->
    <v-card class="recovery-container2" elevation="8">
      <div class="pessoas-redefinir-senha-header mt-3">
        <span>
          <v-icon color="tertiary" size="30" class="mr-2">
            mdi-lock-reset
          </v-icon>
        </span>
        <h1>Recuperação de Senha</h1>
      </div>
      <v-form @submit.prevent="recuperarSenha()" class="recovery-form">
        <v-row class="mt-12 mb-4">
          <BaseTextField
            label="Nova senha"
            required
            id="senha"
            name="senha"
            placeholder="******"
            v-model="dados.senha"
            tabindex="1"
            autocomplete="off"
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? $config.icons.viewOff : $config.icons.view"
            @click:append="show1 = !show1"
          ></BaseTextField>
        </v-row>
        <v-row class="mb-4">
          <BaseTextField
            label="Confirmar nova senha"
            required
            id="senha2"
            name="senha2"
            placeholder="******"
            v-model="senha2"
            :type="show2 ? 'text' : 'password'"
            tabindex="2"
            autocomplete="off"
            :append-icon="show2 ? $config.icons.viewOff : $config.icons.view"
            @click:append="show2 = !show2"
          ></BaseTextField>
        </v-row>
        <v-row class="mb-1">
          <v-btn
            height="48"
            class="button button-bg rounded-lg"
            tabindex="3"
            block
            type="submit"
            :loading="$pessoas_usuarios.recovery_loading"
          >
            <span class="recovery-text2">Recuperar</span>
          </v-btn>
        </v-row>
        <v-row>
          <v-btn text :ripple="false" plain @click="$router.push('/')" block>
            <v-icon class="mr-2"> mdi-arrow-left </v-icon>
            <span class="recovery-text2">Voltar para o login</span>
          </v-btn>
        </v-row>
      </v-form>
    </v-card>
    <waves />
  </div>
</template>
<script>
import waves from "@/components/global/waves.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";

export default {
  name: "ProducerRecoveryPassword",
  components: {
    waves,
    BaseTextField,
  },
  metaInfo: {
    title: "Recuperação de Senha - ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Recuperação de Senha - ElevenTickets",
      },
    ],
  },
  data() {
    return {
      show1: false,
      show2: false,
      dados: {
        email: "",
        senha: "",
        token: "",
        loja: "",
      },
      senha2: "",
    };
  },
  methods: {
    recuperarSenha() {
      if (this.dados.senha != this.senha2) {
        this.$config.alert(
          "As senhas são incompatíveis!",
          this.$config.dados.errorColor
        );
        return;
      }

      this.$lojas_usuarios.recoverySenha(this.dados);
    },
    getParams() {
      if (this.$route.query.loja) {
        this.dados.loja = this.$route.query.loja;
      }

      if (this.$route.query.email) {
        this.dados.email = this.$route.query.email;
      }

      if (this.$route.query.token) {
        this.dados.token = this.$route.query.token;
      } else {
        this.$router.push({ name: "login" });
      }
    },
  },
  mounted() {
    this.getParams();
  },
};
</script>
<style scoped>
.recovery-main {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.recovery-container {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.recovery-container2 {
  width: 550px;
  height: auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  z-index: 3;
}

.recovery-form {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.625rem;
}

.recovery-textinput {
  width: 100%;
  height: 51px;
  border-width: 0px;
  border-radius: 10px;
  margin-bottom: 2rem !important;
}

.recovery-navlink {
  width: 100%;
  height: 51px;
  display: flex;
  text-align: center;
  align-items: center;
  border-radius: 10px;
  flex-direction: row;
  justify-content: center;
}

.recovery-text2 {
  font-size: 1rem;
}

.recovery-omni-logo {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.recovery-container1 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pessoas-redefinir-senha-header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
